module.exports = __webpack_public_path__ + "img/3-min.07296f84.jpg";